module.exports = __webpack_public_path__ + "static/media/market_partner.f80caba6.png";